import React from 'react';
import { Icon, Text } from '@/ui-kits';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { FileItem } from '@/interface';
import { FilePreview } from '../../../common/FilePreview';
import { cn } from '@/utils/common_functions';

interface PatientFilesProps {
  isExpanded: boolean;
  onToggle: () => void;
  files: FileItem[];
  patientQuery?: string;
}

const PatientFiles: React.FC<PatientFilesProps> = ({
  isExpanded,
  onToggle,
  files,
  patientQuery,
}) => {
  const handleView = (file: FileItem) => {
    if (file.url) window.open(file.url, '_blank');
  };
  return (
    <div className="flex flex-col bg-white rounded-lg gap-6 border border-ui_input_border_dark/40">
      {patientQuery && <div className="px-6 pt-6">
        <div className="flex items-center gap-2">
          <Icon type="box_question" className="size-5" />
          <Text variant='title' className="text-ui_blue">Question from Patient</Text>
        </div>
        <Text className="text-ui_input_border_dark ml-8 !font-FigtreeRegular">"{patientQuery}"</Text>
      </div>}

      <div className={cn("px-6 pb-6", !patientQuery && 'pt-6')}>
        <button
          className="flex items-center justify-between cursor-pointer w-full"
          onClick={onToggle}>
          <div className="flex items-center gap-2">
            <Icon type="folder" className="size-5" />
            <Text variant='title' className="text-ui_blue">
              Patient Uploaded Files
            </Text>
          </div>
          {isExpanded ? (
            <ChevronUp className="size-6 text-ui_blue" />
          ) : (
            <ChevronDown className="size-6 text-ui_blue" />
          )}
        </button>

        {isExpanded && (
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            {files.map(file => (
              <FilePreview key={file.id} file={file} handleView={handleView} allowed_actions={[]} readonly />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientFiles;
